import { useState } from "react";
import { useDispatch } from "react-redux";

import { message } from "antd";
import { sendExpressCheckInRequest } from "../../../reducer/bookingReducer";

const useExpressCheckIn = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const submitExpressCheckIn = async (payload) => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        sendExpressCheckInRequest(payload),
      ).unwrap();
      message.success("Express CheckIn request sent successfully");
      return response;
    } catch (error) {
      console.log(error?.response?.data?.message || error.message);

      message.error(
        error?.response?.data?.message ||
          error.message ||
          "Something Went Wrong!",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { submitExpressCheckIn, isLoading };
};

export default useExpressCheckIn;
